import axios from '@/api/libs/api.request'

/**
 * 提交预印本
 * @param {Object} data {
 *   userInfo: { email, name },
 *   title: string,
 *   abstractText: string,
 *   keywords: string,
 *   preprintType: string,
 *   manuscriptFilePath: string,
 *   manuscriptFileName: string,
 *   authors: [{ authorName, authorEmail, authorAffiliation, authorOrder, isCorresponding }]
 * }
 */
export const submitPreprint = data => {
  return axios.request({
    url: '/preprint/submit',
    method: 'post',
    data: data
  })
}

/**
 * 获取公开预印本列表
 * @param {Object} data { current, size, keyword, preprintType }
 */
export const getPreprintList = data => {
  return axios.request({
    url: '/preprint/list',
    method: 'post',
    data: data
  })
}

/**
 * 获取我的预印本列表
 * @param {Object} data { userInfo: { email }, current, size }
 */
export const getMyPreprintList = data => {
  return axios.request({
    url: '/preprint/myList',
    method: 'post',
    data: data
  })
}

/**
 * 获取预印本详情
 * @param {Object} data { id }
 */
export const getPreprintDetail = data => {
  return axios.request({
    url: '/preprint/detail',
    method: 'post',
    data: data
  })
}


/**
 * 重新提交预印本
 * 后端通过 submit 接口 + body.id 是否存在来判断是否为重新提交
 */
export const resubmitPreprint = data => {
  return axios.request({
    url: '/preprint/submit',
    method: 'post',
    data: data
  })
}

/**
 * 审核预印本（管理员）
 * @param {Object} data {
 *   userInfo: { email, name },
 *   preprintId: string,
 *   approved: boolean,
 *   opinion: string
 * }
 */
export const auditPreprint = data => {
  return axios.request({
    url: '/preprint/audit',
    method: 'post',
    data: data
  })
}

/**
 * 下架预印本（管理员）
 * @param {Object} data {
 *   userInfo: { email, name },
 *   preprintId: string,
 *   reason: string
 * }
 */
export const offlinePreprint = data => {
  return axios.request({
    url: '/preprint/offline',
    method: 'post',
    data: data
  })
}

/**
 * 获取待审核预印本列表（管理员）
 * @param {Object} data { current, size }
 */
export const getPendingPreprintList = data => {
  return axios.request({
    url: '/preprint/pendingList',
    method: 'post',
    data: data
  })
}

/**
 * 提交评论
 * @param {Object} data {
 *   userInfo: { email, name },
 *   preprintId: string,
 *   commentContent: string
 * }
 */
export const submitComment = data => {
  return axios.request({
    url: '/preprint/submitComment',
    method: 'post',
    data: data
  })
}

/**
 * 获取预印本的评论列表
 * @param {Object} data { preprintId, current, size }
 */
export const getCommentList = data => {
  return axios.request({
    url: '/preprint/commentList',
    method: 'post',
    data: data
  })
}

/**
 * 获取我的评论列表
 * @param {Object} data { userInfo: { email }, current, size }
 */
export const getMyCommentList = data => {
  return axios.request({
    url: '/preprint/myCommentList',
    method: 'post',
    data: data
  })
}

/**
 * 审核评论（管理员）
 * @param {Object} data {
 *   userInfo: { email },
 *   commentId: string,
 *   approved: boolean,
 *   rejectReason: string
 * }
 */
export const auditComment = data => {
  return axios.request({
    url: '/preprint/auditComment',
    method: 'post',
    data: data
  })
}

/**
 * 获取待审核评论列表（管理员）
 * @param {Object} data { current, size }
 */
export const getPendingCommentList = data => {
  return axios.request({
    url: '/preprint/pendingCommentList',
    method: 'post',
    data: data
  })
}

/**
 * 增加浏览次数
 * @param {Object} data { id }
 */
export const incrementViewCount = data => {
  return axios.request({
    url: '/preprint/view',
    method: 'post',
    data: data
  })
}

/**
 * 增加下载次数
 * @param {Object} data { id }
 */
export const incrementDownloadCount = data => {
  return axios.request({
    url: '/preprint/download',
    method: 'post',
    data: data
  })
}

/**
 * 转为正式稿件
 * @param {Object} data {
 *   userInfo: { email, name },
 *   preprintId: string
 * }
 */
export const convertToManuscript = data => {
  return axios.request({
    url: '/preprint/convertToManuscript',
    method: 'post',
    data: data
  })
}

/**
 * 获取审计日志列表（管理员）
 * @param {Object} data { userInfo, operationType, current, size }
 */
export const getAuditLogList = data => {
  return axios.request({
    url: '/preprint/auditLogList',
    data,
    method: 'post'
  })
}

/**
 * 删除评论（评论本人或审核编辑可删）
 * @param {Object} data {
 *   userInfo: { email, type },
 *   commentId: string
 * }
 */
export const deleteComment = data => {
  return axios.request({
    url: '/preprint/deleteComment',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/preprint.js